import * as React from 'react';
import { memo } from 'react';

const SvgHeadset = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.162 9.959h-2.4a1.2 1.2 0 0 0-1.2 1.2v3a1.2 1.2 0 0 0 1.2 1.2h1.2a1.2 1.2 0 0 0 1.2-1.2v-4.2Zm0 0a7.202 7.202 0 0 0-7.26-7.2 7.2 7.2 0 0 0-7.252 7.2v4.2a1.2 1.2 0 0 0 1.2 1.2h1.2a1.2 1.2 0 0 0 1.2-1.2v-3a1.2 1.2 0 0 0-1.2-1.2h-2.4", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M17.163 14.159v1.8a2.4 2.4 0 0 1-2.4 2.4H10.45", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgHeadset);

export { Memo as default };
